import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import commonEn from "./en/commonEn";
import dashboardEn from "./en/dashboardEn";
import masterEn from "./en/masterEn";
import settingsEn from "./en/settings";
import usersEn from "./en/users";
import vendorEn from "./en/vendorEn";
import subscriptionEn from "./en/subscriptionEn";
import { shopEn } from "./en/shopEn";

const resources = {
    en: {
        translation: {
            ...commonEn,
            ...dashboardEn,
            ...masterEn,
            ...settingsEn,
            ...usersEn,
            ...vendorEn,
            ...subscriptionEn,
            ...shopEn,
        }
    },
};

// Initialize i18next
i18n.use(initReactI18next).init({
    resources,
    lng: "en", // Default language
    fallbackLng: "en",
    interpolation: { escapeValue: false }
});

export default i18n;